(() => {
  const root = window.Shopify?.routes?.root || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: window.IndusTheme?.currency || 'INR', maximumFractionDigits: 2 }).format((Number(cents) || 0) / 100);
  const toast = (message) => {
    const node = document.querySelector('[data-io-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(node._timer);
    node._timer = setTimeout(() => node.classList.remove('is-visible'), 2600);
  };

  class IndusCartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-close]') || event.target === this.querySelector('[data-cart-overlay]')) this.close();
        const change = event.target.closest('[data-cart-change]');
        if (change) this.change(Number(change.dataset.line), Number(change.dataset.quantity));
      });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape') this.close(); });
      document.addEventListener('indus:cart-refresh', () => this.refresh(true));
    }
    open() { this.setAttribute('open', ''); this.setAttribute('aria-hidden', 'false'); document.body.classList.add('io-lock'); this.querySelector('[data-cart-close]')?.focus(); }
    close() { this.removeAttribute('open'); this.setAttribute('aria-hidden', 'true'); document.body.classList.remove('io-lock'); }
    async refresh(openAfter = false) {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      this.render(cart);
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
      if (openAfter) this.open();
    }
    async change(line, quantity) {
      this.classList.add('is-loading');
      try {
        const response = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
        if (!response.ok) throw new Error('Could not update cart');
        this.render(await response.json());
      } catch (error) { toast(error.message); }
      finally { this.classList.remove('is-loading'); }
    }
    render(cart) {
      const list = this.querySelector('[data-cart-items]');
      const empty = this.querySelector('[data-cart-empty]');
      const footer = this.querySelector('[data-cart-footer]');
      list.innerHTML = cart.items.map((item, index) => `
        <article class="io-cart-line">
          <a class="io-cart-line__image" href="${item.url}">${item.featured_image?.url ? `<img src="${item.featured_image.url}?width=240" alt="${this.escape(item.product_title)}" width="120" height="120">` : ''}</a>
          <div class="io-cart-line__body"><a href="${item.url}"><strong>${this.escape(item.product_title)}</strong></a>${item.variant_title ? `<small>${this.escape(item.variant_title)}</small>` : ''}<span>${money(item.final_line_price)}</span><div class="io-cart-qty"><button type="button" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0,item.quantity - 1)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button></div></div>
        </article>`).join('');
      empty.hidden = cart.item_count > 0;
      list.hidden = cart.item_count === 0;
      footer.hidden = cart.item_count === 0;
      this.querySelector('[data-cart-subtotal]').textContent = money(cart.total_price);
      const threshold = Number(this.dataset.freeShipping || 0);
      const message = this.querySelector('[data-shipping-message]');
      const bar = this.querySelector('[data-shipping-bar]');
      if (threshold > 0) {
        const remaining = Math.max(0, threshold - cart.total_price);
        message.textContent = remaining ? `${money(remaining)} away from free shipping` : 'Free shipping unlocked!';
        bar.style.width = `${Math.min(100, (cart.total_price / threshold) * 100)}%`;
      }
      document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
    }
    escape(value) { const div = document.createElement('div'); div.textContent = value || ''; return div.innerHTML; }
  }
  customElements.define('indus-cart-drawer', IndusCartDrawer);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener) { event.preventDefault(); document.querySelector('indus-cart-drawer')?.refresh(true); }
    const modalOpen = event.target.closest('[data-modal-open]');
    if (modalOpen) {
      const modal = document.getElementById(modalOpen.dataset.modalOpen);
      if (modal) { modal.setAttribute('aria-hidden','false'); document.body.classList.add('io-lock'); modal.querySelector('button,input,a')?.focus(); }
    }
    const modalClose = event.target.closest('[data-modal-close]');
    if (modalClose) { const modal = modalClose.closest('.io-modal'); modal?.setAttribute('aria-hidden','true'); document.body.classList.remove('io-lock'); }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.io-modal[aria-hidden="false"]').forEach((modal) => modal.setAttribute('aria-hidden','true'));
    document.body.classList.remove('io-lock');
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-indus-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-busy','true');
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || 'Could not add this item');
      document.dispatchEvent(new CustomEvent('indus:cart-refresh'));
      toast(`${payload.product_title || 'Item'} added to your bag`);
    } catch (error) { toast(error.message); }
    finally { button?.removeAttribute('aria-busy'); }
  });

  window.IndusTheme = Object.assign(window.IndusTheme || {}, { money, toast, refreshCart: (open = false) => document.querySelector('indus-cart-drawer')?.refresh(open) });
})();
